import classNames from 'classnames';
import { PropsWithChildren } from 'react';

import style from './card.module.css';

type CardBackgroundColor = 'black' | 'white';
export type CardBorder = 'black' | 'none' | 'turquoise';

interface CardProps {
  backgroundColor: CardBackgroundColor;
  border: CardBorder;
  className?: string;
  elementCount?: number;
  id?: string;
}

const cardBackgroundColorMap: Record<CardBackgroundColor, string> = {
  black: style.cardBlack,
  white: style.cardWhite,
};

const cardBorderMap: Record<CardBorder, string> = {
  black: style.cardBorderBlack,
  none: style.cardBorderNone,
  turquoise: style.cardBorderTurquoise,
};

const Card = ({
  backgroundColor,
  border,
  children,
  className,
  elementCount,
  id,
}: PropsWithChildren<CardProps>) => {
  return (
    <article
      className={classNames(
        cardBackgroundColorMap[backgroundColor],
        cardBorderMap[border],
        style.card,
        className,
      )}
      id={id}
      style={{
        ...elementCount
          ? {
            gridRow: `auto / span ${elementCount.toString()}`,
          }
          : {},
      }}
    >
      {children}
    </article>
  );
};

export default Card;
